import { jsxs as t, jsx as o } from "react/jsx-runtime";
function e(r) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ o("path", { d: "M13.5 8.5H2.5", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        /* @__PURE__ */ o("path", { d: "M7 4L2.5 8.5L7 13", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
      ]
    }
  );
}
export {
  e as ArrowLeftIcon
};
